import React from 'react';
import PropTypes from 'prop-types';
import NachaMessage from "../NachaMessage";
import {paymentProfiles, paymentVerifications} from '../../../ducks/index';
import {connect} from 'react-redux';
import {paymentInputDefaultProps, paymentInputPropTypes} from "./PaymentSelector";
import PaymentProfileOptions from "../detailInputs/PaymentProfileOptions";
import {stringParams} from 'utils';

class PendingAchInput extends React.Component {
  static propTypes = {
    ...paymentInputPropTypes,
    buttonText: PropTypes.func,
    submittingText: PropTypes.func,

    paymentProfile: PropTypes.object
  };

  static defaultProps = {
    ...paymentInputDefaultProps,
    buttonText: () => 'Submit Payment',
    submittingText: () => 'Submitting Payment...'
  };

  static validAmount = /^\d?\.\d{2}$/;

  constructor() {
    super();

    this.state = {
      submitting: false,
      micro_deposit_0: '',
      micro_deposit_1: '',
      savePaymentProfile: true,
      autopay: true
    };
  }

  verifyAmounts() {
    const {
      micro_deposit_0,
      micro_deposit_1,
      savePaymentProfile,
      autopay
    } = this.state;

    this.setState({
      submitting: true,
      error: false
    });

    this.props.beforeSubmit()
      .then(() => this.props.verifyAmounts(micro_deposit_0, micro_deposit_1))
      .then(() =>
        this.props.onSubmit({
          paymentDetails: this.props.paymentProfile,
          payment_method: "payment profile",
          token: this.props.paymentProfile.id,
          savePaymentProfile,
          autopay
        })
      )
      .then(({order, payment_profile}) => {
        if(savePaymentProfile) {
          return this.props.updateProfile({autopay}).then(() => Promise.resolve({order, payment_profile}));
        }
        else {
          return this.props.deleteProfile().then(() => Promise.resolve({order, payment_profile}));
        }
      })
      .then(this.props.afterSubmit)
      .then(() => {
        this.setState({
          submitting: false
        })
      })
      .catch((response) => {
        this.setState({
          submitting: false,
          error: true,
          errorMessage: response.message
        });

        paymentVerifications.actions.denormalizeObjects(response).then(({payment_verification}) => {
          if(payment_verification.status == 'failed') {
            this.props.reloadProfile();
          }
        });
      })
    ;
  }

  updateMicrodeposit(num) {
    return (event) => {
      // Only allow user to enter values that look like X.XX or a substring thereof
      const matches = event.target.value.match(/^(\d{0,1}(\.\d{0,2})?|\.\d{0,2})/);

      if (matches) {
        this.setState({
          [`micro_deposit_${num}`]: matches[1]
        });
      }
    }
  }

  isValid() {
    const {
      micro_deposit_0,
      micro_deposit_1
    } = this.state;

    return micro_deposit_0 != null && micro_deposit_0.match(this.constructor.validAmount)
      && micro_deposit_1 != null && micro_deposit_1.match(this.constructor.validAmount);
  }

  render() {
    const {
      amount,
      billingConfig,
      customer,
      showSaveProfileOption,
      showAutopayOption,
      paymentProfile
    } = this.props;

    const {
      submitting,
      error,
      errorMessage,
      savePaymentProfile,
      autopay
    } = this.state;
    const disabled = !this.isValid() || this.props.disabled || submitting;

    const buttonText = this.props.buttonText(customer, paymentProfile.payment_method);
    const submittingText = this.props.submittingText(customer, paymentProfile.payment_method);

    const isFailed = !!paymentProfile.payment_verification && paymentProfile.payment_verification.status === 'failed';

    if (isFailed) {
      return <div className={'alert alert-danger'}>
        Maximum verification attempts exceeded.  Please select another payment method or re-enter account info and try again.
      </div>;
    }

    return <div>
      {!!error && <div className={'alert alert-danger'}>
        {errorMessage || 'There was an error verifying your payments. Please check the numbers and try again.'}
      </div>}

      <div className={'alert alert-info'}>
        Please check your bank statement and input the two micro deposits shown in the order that they were made.
        Be sure to include the decimal point and both decimal places.
      </div>

      <fieldset className={'payment-ach-input ach-pending'}>
        <label className={`payment-ach-field`}>
          <span className={'payment-input-label'}>
            Micro Deposit 1:
          </span>

          <span className={'payment-input-field-prefix'}>
            $&nbsp;
          </span>
          <input type={'text'}
                 className={'payment-input-field'}
                 id={'micro_deposit_0'}
                 name={'micro_deposit_0'}
                 onChange={this.updateMicrodeposit(0)}
                 placeholder={"0.00"}
                 value={this.state.micro_deposit_0}
                 disabled={submitting}
          />
        </label>

        <label className={`payment-ach-field`}>
          <span className={'payment-input-label'}>
            Micro Deposit 2:
          </span>


          <span className={'payment-input-field-prefix'}>
            $&nbsp;
          </span>
          <input type={'text'}
                 className={'payment-input-field'}
                 id={'micro_deposit_1'}
                 name={'micro_deposit_1'}
                 onChange={this.updateMicrodeposit(1)}
                 placeholder={'0.00'}
                 value={this.state.micro_deposit_1}
                 disabled={submitting}
          />
        </label>
      </fieldset>

      <PaymentProfileOptions
        billingConfig={billingConfig}
        customer={customer}
        paymentMethod={'electronic check'}
        showSaveProfileOption={showSaveProfileOption}
        showAutopayOption={showAutopayOption}
        savePaymentProfile={savePaymentProfile}
        autopay={autopay}
        onChange={(props) => this.setState(props)}
        disabled={submitting}
      />

      <button className={'btn btn-primary submit-payment-profile'}
              onClick={() => this.verifyAmounts()}
              disabled={disabled}
      >
        {submitting ? submittingText : `Verify My Account Details and ${buttonText}`}
      </button>

      <NachaMessage amount={amount}
                    buttonText={buttonText}
                    customer={customer}/>
    </div>;
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    verifyAmounts: (amount_1, amount_2) => dispatch(paymentVerifications.actions.verifyAmounts(ownProps.paymentProfile.payment_verification, amount_1, amount_2)),
    deleteProfile: () => dispatch(paymentProfiles.actions.remove(ownProps.paymentProfile)),
    updateProfile: (opts) => dispatch(paymentProfiles.actions.update({...ownProps.paymentProfile, ...opts})),
    reloadProfile: () => dispatch(paymentProfiles.actions.load({user_id: ownProps.user.id}, stringParams({user_id: ownProps.user.id})))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PendingAchInput);
